// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nnuKLsAElIdCCiWv3ANI{max-height:100%;padding-inline:24px}`, "",{"version":3,"sources":["webpack://./src/pages/chatbot/ui/ChatbotCreate/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA,CACA,mBAAA","sourcesContent":[".presetList {\n  max-height: 100%;\n  padding-inline: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"presetList": `nnuKLsAElIdCCiWv3ANI`
};
export default ___CSS_LOADER_EXPORT___;
